import { jsPDF } from "jspdf";
import { DocumentExportMetadata } from "../models/DocumentExportOptions";

export const addPdfDocumentFooters = (document: jsPDF, metadata: DocumentExportMetadata) => {
  const pageCount = document.getNumberOfPages();
  const pageWidth = document.internal.pageSize.getWidth();
  const pageHeight = document.internal.pageSize.getHeight();

  for (let page = 1; page <= pageCount; page += 1) {
    document.setPage(page);
    document.setDrawColor(220, 226, 232);
    document.line(14, pageHeight - 14, pageWidth - 14, pageHeight - 14);
    document.setFont("helvetica", "normal");
    document.setFontSize(8);
    document.setTextColor(100, 116, 139);
    document.text(`Generated ${metadata.createdDate ?? new Date().toLocaleString()}`, 14, pageHeight - 8);
    document.text(`Page ${page} of ${pageCount}`, pageWidth - 14, pageHeight - 8, { align: "right" });
  }
};
